import { useMemo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { spacing } from '../../theme/public-api';

/**
 * Padding para el contenedor exterior de un `Modal` a pantalla completa.
 * Combina `spacing.lg` con los insets del dispositivo (notch, home indicator).
 * Usar junto a `styles.modalBackdrop` de Pos/reports (sin padding propio en el StyleSheet base).
 */
export function useModalBackdropPadding() {
  const insets = useSafeAreaInsets();
  return useMemo(
    () => ({
      paddingTop: spacing.lg + insets.top,
      paddingBottom: spacing.lg + insets.bottom,
      paddingLeft: spacing.lg + insets.left,
      paddingRight: spacing.lg + insets.right,
    }),
    [insets.top, insets.bottom, insets.left, insets.right],
  );
}
